export const getCashupState = (state) => state.cashup;

export const getCashupHistoryState = (state) => state.cashupHistory;
